import styled, { css } from 'styled-components';

export const buttonStyles = css`
	display: flex;
	flex: 0 0 auto;
	width: 4rem;
	height: 4rem;
	background: transparent;
	cursor: pointer;
	margin-right: 0.5rem;
	transition: color 150ms, background-color 150ms;
	border: 1px solid ${({ theme }) => theme.colors.borderColor};
	font-family: ${({ theme }) => theme.fonts.ArimoRegular};
	font-size: 1.4rem;

	${({ theme, pagerTheme }) => {
		if (!pagerTheme || pagerTheme === 'primary') {
			return css`
				color: ${theme.colors.primary};

				&.selected,
				&:hover {
					background-color: ${theme.colors.primary};
					color: #fff;

					svg g {
						fill: #fff;
					}
				}

				svg g {
					fill: ${theme.colors.primary};
				}
			`;
		}
		if (pagerTheme === 'default') {
			return css`
				color: ${theme.colors.textColor};

				&.selected,
				&:hover {
					color: ${theme.colors.textDark};
					border-color: ${theme.colors.borderDark};

					svg g {
						fill: ${theme.colors.textDark};
					}
				}

				svg g {
					fill: ${theme.colors.textColor};
				}
			`;
		}

		return '';
	}}

	&.disabled {
		opacity: 0.5;
		pointer-events: none;
	}

	a {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
		height: 100%;
	}
`;

export const Wrapper = styled.div`
	ul {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		list-style: none;

		li {
			${buttonStyles};
		}
	}
`;
